import React from 'react'

const Section = ({ title, children }) => {
  return (
    <div className="space-y-2">
    <h3 className="text-base font-semibold text-cyan-800 border-b border-gray-200 pb-1">
      {title}
    </h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
      {children}
    </div>
  </div>
  )
}

export default Section
